import { Skeleton } from '@components/ui/skeleton';
import React from 'react';
import { Spinner } from './spinner.component';

export type LoadingType = 'spinner' | 'skeleton';

export type LoadingStateContainerProps = {
  contentLines?: number;
  message?: string | null;
  type?: LoadingType;
};

export const LoadingStateContainer: React.FC<LoadingStateContainerProps> = (props) => {
  const { contentLines = 3, message = 'Loading...', type = 'spinner' } = props;

  return (
    <>
      {type === 'spinner' && (
        <div className="flex items-center justify-center m-auto">
          <div className="flex flex-col items-center">
            {message && <div className="text-gray-500 pb-4">{message}</div>}
            <Spinner size="lg" />
          </div>
        </div>
      )}

      {type === 'skeleton' && (
        <div className="space-y-3">
          {Array.from({ length: contentLines }).map((_, i) => (
            <Skeleton
              key={i}
              className={`h-4 ${i === contentLines - 1 ? 'w-2/3' : 'w-full'}`}
            />
          ))}
        </div>
      )}
    </>
  );
};
